class window.YaMap
  constructor: (selector_id, latitude, longitude, content) ->
    self = this
    @mapSelector = selector_id
    @latitude = latitude
    @longitude = longitude
    @content = content
    @zoom = 16
    @yaMap = undefined
    @yMaps = ymaps

    @init()

  init: =>
    self = this

    console.log $('#' + @mapSelector)[0]
    if $('#' + @mapSelector)[0] != undefined
      @yMaps.ready ->
        self.yaMap = new self.yMaps.Map(self.mapSelector, {
          center: [self.latitude, self.longitude]
          zoom: self.zoom
          controls: []
        })

        myPlacemark = new self.yMaps.Placemark(
          [self.latitude, self.longitude],
          {
            balloonContent: '<p>'+self.content+'</p>'
          }
        )

        self.yaMap.behaviors.disable('scrollZoom')
        self.yaMap.geoObjects.add(myPlacemark)


// WEBPACK FOOTER //
// ./assets/javascripts/app/ya_map.coffee